import { Dispatch, useEffect, useState } from 'react';
import { EmployeeSettingsTabTypes, Entity } from './types';
import { GeneralTab } from './Tabs/GeneralTab';
import { ImportMappingTab } from './Tabs/ImportMappingTab';
import { ConnectionGrid } from './Tabs/ConnectionGrid';
import {
  useGetConnectionTableData,
  useGetGeneralTableData
} from './useGetConnectionTableData';
import { AFASConnectorTab } from './Tabs/AFASConnectorTab';
import {
  getPropertyMappings,
  useGetAFASConnections,
  useGetAFASImportMappings
} from './useGetAFASSettings';

type TabSwitcherProps = {
  currentTab: EmployeeSettingsTabTypes;
  setAFASSelected: Dispatch<boolean>;
};

export const TabSwitcher = ({
  currentTab,
  setAFASSelected
}: TabSwitcherProps) => {
  const [defaultPropArray, setDefaultPropArray] =
    useState<Entity['propertyMappings']>();
  const { connectionTable, isFetching } = useGetConnectionTableData();
  const { tableData, isFetching: isFetchingGeneral } = useGetGeneralTableData();
  const { AFASConnectors, isFetchingAFASConnections } = useGetAFASConnections();
  const { data: entityMappings, isFetchingAFASImportMappings } =
    useGetAFASImportMappings();

  useEffect(() => {
    getPropertyMappings(1).then((r) =>
      setDefaultPropArray(r.data.propertyMappings)
    );
  }, []);

  switch (currentTab) {
    case EmployeeSettingsTabTypes.CONNECTION_SETTINGS:
      return (
        <ConnectionGrid
          connectionTable={connectionTable}
          isFetching={isFetching}
        />
      );
    case EmployeeSettingsTabTypes.AFAS_CONNECTORS:
      return (
        <AFASConnectorTab
          AFASConnectors={AFASConnectors}
          isFetching={isFetchingAFASConnections}
        />
      );
    case EmployeeSettingsTabTypes.IMPORT_MAPPINGS:
      return (
        <ImportMappingTab
          entityMappings={entityMappings}
          isFetchingAFASImportMappings={isFetchingAFASImportMappings}
          defaultPropArray={defaultPropArray}
        />
      );
    default:
      return (
        <GeneralTab
          tableData={tableData}
          isFetching={isFetchingGeneral}
          setAFASSelected={setAFASSelected}
        />
      );
  }
};
